



































































































































import { Vue, Component, Watch } from "vue-property-decorator";

import cartTable from "@/components/cartTable.vue";
import reportsSmall from "@/components/reportsSmall.vue";
import reportsExpanded from "@/components/reportsExpanded.vue";
import pay from "@/components/pay.vue";
import receipt from "@/components/receipt.vue";

import fitty from "fitty";
import RequestHandler from "@/assets/ts/requestHandler";
const requestHandler = new RequestHandler();

@Component({
  components: {
    cartTable,
    reportsSmall,
    reportsExpanded,
    pay,
    receipt
  }
})
export default class Home extends Vue {
  hubAppLink = "";
  hubAppSSERetry: any = 0;
  hubAppSSEError: any = 0;
  tableHeaders: Array<any> = [];
  apiFields: Array<any> = [];
  cartItems: Array<any> = [];
  expanded = false;
  dialogs = {
    pay: false
  };
  payType = "";
  options: {
    minSize: number;
    maxSize: number;
    multiLine: boolean;
  } = {
    minSize: 1,
    maxSize: 60,
    multiLine: false
  };

  pay(type: string) {
    this.payType = type;
    this.dialogs.pay = true;
  }

  handleChartClick(type: string) {
    this.expanded = true;
    this.$nextTick(() => {
      switch (type) {
        case "Monthly":
          (this.$refs.expandedReport as any).quickSearchSelection = (this.$refs
            .expandedReport as any).quickSearchItems[4].value;
          break;
        case "Weekly":
          (this.$refs.expandedReport as any).quickSearchSelection = (this.$refs
            .expandedReport as any).quickSearchItems[2].value;
          break;
        case "Daily":
          (this.$refs.expandedReport as any).quickSearchSelection = (this.$refs
            .expandedReport as any).quickSearchItems[0].value;
          break;
      }
      (this.$refs.expandedReport as any).quickSearch();
    });
  }

  finishTrans(resp: any) {
    (this.$refs.receipt as any).receipt(resp.paymentId, "print");
    (this.cartItems as any).splice(0, this.cartItems.length);
    (this.$refs.cartTable as any).addNewItem();
  }

  get canPay(): boolean {
    if (
      this.$refs.cartTable != undefined &&
      !(this.$refs.cartTable as any).validateAllCartItems(false)
    )
      return false;

    if (this.$store.getters.hubAppDisconnected || this.totalDue <= 0) {
      return false;
    }
    return true;
  }

  get optionTypes() {
    const options: Array<string> = [];
    this.apiFields.forEach((option: any) => {
      options.push(option.optionType);
    });
    return options;
  }

  get formattedCartItems() {
    const formattedArr: Array<any> = [];
    this.cartItems.forEach((item: any) => {
      if (item.type != undefined) {
        const t: any = { optionType: item.type };
        for (let i = 0; i < item.fields[t.optionType].length; i++) {
          Vue.set(t, `field${i + 1}Val`, item.fields[t.optionType][i].value);
        }
        Vue.set(t, "billAmt", item.amount);
        Vue.set(t, "conAmt", 0);
        Vue.set(t, "countyId", this.$store.getters.userInfo.CountyID);
        Vue.set(t, "userId", this.$store.getters.userInfo.UserID);
        Vue.set(t, "monetraAccount", this.$store.getters.userInfo.monetra_user);
        formattedArr.push(t);
      }
    });
    return formattedArr;
  }

  get totalDue() {
    let total = 0;
    this.cartItems.forEach((item: any) => {
      total += [undefined, null, ""].includes(item.amount)
        ? 0
        : parseFloat(item.amount);
    });
    return total;
  }

  resizeText(): void {
    fitty(this.$refs.fitText as HTMLElement, this.options);
  }

  @Watch("totalDue")
  onClassChanged() {
    this.resizeText();
  }

  async beforeCreate() {
    this.hubAppLink =
      (await requestHandler.getConfig()).config.hubDownloadBaseLocation +
      "StarInstaller.exe";
  }

  async created() {
    this.hubAppSSERetryHandler();
    try {
      if (this.$store.getters.fields.length == 0) {
        const fields = await requestHandler.call({
          action: "paymentFields"
        });
        this.$store.dispatch("setFields", fields);
      }

      this.$store.getters.fields.forEach((item: any) => {
        this.apiFields.push(item);
      });
    } catch (e) {
      if (
        e.response != undefined &&
        e.response.status != undefined &&
        e.response.status == "401"
      ) {
        return;
      }
      this.$root.$emit("snackbar-message", {
        text: "Unable to load payment fields.",
        color: "red"
      });
      console.error(e);
    }
    if (this.apiFields.length > 1)
      this.tableHeaders.push({
        text: "Type",
        value: "type",
        sortable: false
      });
    this.tableHeaders.push(
      {
        text: "Fields",
        value: "fields",
        sortable: false
      },
      {
        text: "Amount",
        value: "amount",
        sortable: false
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false
      }
    );
    //wait for component update
    this.$nextTick(() => {
      (this.$refs.cartTable as any).addNewItem();
      this.resizeText();
    });
  }

  async hubAppSSERetryHandler() {
    await this.$store.dispatch("startHubSSE");
    window.clearInterval(this.hubAppSSERetry);
    this.$store.getters["hubAppEventSource"].onopen = async () => {
      clearTimeout(this.hubAppSSEError);
      this.$store.dispatch("setHubAppDisconnected", false);
      window.clearInterval(this.hubAppSSERetry);
    };

    this.$store.getters["hubAppEventSource"].onerror = () => {
      this.hubAppSSERetry = setInterval(() => {
        this.hubAppSSERetryHandler();
      }, 3000);
      this.hubAppSSEError = setTimeout(() => {
        this.$store.dispatch("setHubAppDisconnected", true);
      }, 5000);
    };
  }
}
